
import { DeviceActivity } from '../DeviceActivity';

export class DeviceActivityPartner extends DeviceActivity {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/DeviceActivityPartner.js